import React, { useState, useEffect } from 'react';
const Swal = window.Swal;
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CardIjinKonfirmasi = ({ item, onSetujuClick }) => {
  const tanggalList = item.log
    ? item.log.split(',').map(t => t.trim())
    : [];

  const formatTanggal = (ymd) => {
    if (!ymd) return '-';
    const date = new Date(ymd);
    return date.toLocaleDateString('id-ID', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).replace(/\//g, '-');
  };

  const tanggalTampilan = tanggalList.map(formatTanggal).join(' s/d ');


  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 12,
        padding: 25,
        marginBottom: 16,
        border: '1px solid #e0e0e0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        fontFamily: '"Segoe UI", "Roboto", sans-serif',
      }}
    >
      <div>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
          <div>
            <h4 style={{
              fontWeight: 600,
              fontSize: 16,
              margin: '0 0 6px 0',
              color: '#1a1a1a',
              letterSpacing: '0.3px'
            }}>
              {item.nama_karyawan || 'Nama Tidak Diketahui'}
            </h4>
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', fontWeight: 600, padding: '4px 8px', backgroundColor: '#f3f4f6', borderRadius: 8 }}>
            ID: {item.id || 'N/A'}
          </div>
        </div>

        {/* Informasi Pengajuan */}
        <div style={{
          backgroundColor: '#f9f9f9',
          borderRadius: 8,
          padding: 16,
          marginBottom: 16,
          borderLeft: '4px solid #1890ff'
        }}>
          {/* Jenis Izin */}


          {/* Periode Izin */}
          <div style={{ display: 'flex', marginBottom: 8 }}>
            <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Mulai :</div>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#1890ff' }}>
              {tanggalTampilan || item.tanggal}
              {item.jumlah > 1 && (
                <span style={{ marginLeft: 8, color: '#722ed1', fontSize: 13, fontWeight: 500 }}>
                  ({item.jumlah} hari kerja)
                </span>
              )}
            </div>
          </div>

          {/* Periode Izin */}
          <div style={{ display: 'flex', marginBottom: 8 }}>
            <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Masuk :</div>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#1890ff' }}>
              {item.jadwal}
              {item.jumlah > 1 && (
                <span style={{ marginLeft: 8, color: '#722ed1', fontSize: 13, fontWeight: 500 }}>
                  ({item.jumlah} hari kerja)
                </span>
              )}
            </div>
          </div>

          {/* Staf Pengganti */}
          {item.nama_pengganti && (
            <div style={{ display: 'flex', marginBottom: 8 }}>
              <div style={{ width: 90, color: '#595959', fontSize: 14 }}>Pengganti :</div>
              <div style={{ fontWeight: 500, fontSize: 14, color: '#1a1a1a' }}>{item.nama_pengganti}</div>
            </div>
          )}

          {/* Tanggal Pengajuan */}
          {/* <div style={{ display: 'flex', marginBottom: 8 }}>
            <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Diajukan:</div>
            <div style={{ fontSize: 14, color: '#8c8c8c' }}>
              
            </div>
          </div> */}
          {/* Tanggal Pengajuan */}
          {/* <div style={{ display: 'flex' }}>
            <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Jam :</div>
            <div style={{ fontSize: 14, color: '#8c8c8c' }}>
              {new Date(item.created_at).toLocaleString('id-ID', {
                
                hour: '2-digit',
                minute: '2-digit',
              })}
            </div>
          </div> */}
        </div>
        <div style={{ display: 'flex', marginBottom: 8, textAlign: 'center' }}>
          <div style={{ fontSize: 14 }}>Keterangan :</div>
        </div>
        <div style={{ display: 'flex', marginBottom: 8 }}>
          <div style={{ fontWeight: 500, fontSize: 14, color: '#1a1a1a' }}>{item.nama || '-'}</div>
        </div>
        {/* Tanda Tangan */}
        <div style={{
          display: 'flex',

          marginBottom: 10,
          paddingTop: 2,
          borderTop: '1px solid #f0f0f0',
        }}>
          {/* TTD Pemohon */}
          <div style={{ textAlign: 'center', flex: 1 }}>
            <p style={{
              fontSize: 13,
              color: '#595959',
              marginBottom: 8,
              fontWeight: 500
            }}>
              Cilacap, {new Date(item.created_at).toLocaleDateString('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}{' '}
              ({new Date(item.created_at).toLocaleTimeString('id-ID', {
                hour: '2-digit',
                minute: '2-digit',
              })})

            </p>
            {item.ttd_pemohon ? (
              <img
                src={item.ttd_pemohon}
                alt="Tanda tangan pemohon"
                style={{
                  width: 140,
                  height: 80,
                  objectFit: 'contain',
                  border: 'none',
                  borderRadius: 6,
                  backgroundColor: '#fff',
                }}
              />
            ) : (
              <div style={{
                width: 140,
                height: 80,
                border: '1px solid #d9d9d9',
                borderRadius: 6,
                backgroundColor: '#fafafa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#bfbfbf',
                fontSize: 11,
              }}>
                Belum tersedia
              </div>
            )}

          </div>
        </div>
        {/* TTD Penyetuju - Tombol Persetujuan */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <motion.button
            type="button"
            whileHover={{ scale: 1.01, backgroundColor: '#e6f7ff' }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onSetujuClick(item)}
            style={{
              width: '100%',           // 🔑 penuh sesuai div atas
              maxWidth: 480,           // 🔒 biar tidak kepanjangan
              height: 64,
              border: '1px solid #d9d9d9',
              borderRadius: 10,
              backgroundColor: '#fafafa',
              display: 'flex',         // 🔑 berjejer
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 16px',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Kiri: Icon */}
            <div
              style={{
                fontSize: 22,
                color: '#1890ff',
                flexShrink: 0,
              }}
            >
              {item.status === 'disetujui' ? '✅' : '✍️'}
            </div>

            {/* Tengah: Teks */}
            <div
              style={{
                flex: 1,
                textAlign: 'left',
                marginLeft: 12,
              }}
            >
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#1890ff',
                  lineHeight: 1.3,
                }}
              >
                {item.status === 'disetujui'
                  ? 'Pengajuan Telah Disetujui'
                  : 'Beri Persetujuan'}
              </div>

              <div
                style={{
                  fontSize: 11,
                  color: '#8c8c8c',
                  marginTop: 2,
                }}
              >
                {item.status === 'disetujui'
                  ? `Disetujui pada ${new Date(item.tanggal_persetujuan).toLocaleDateString('id-ID')}`
                  : 'Klik untuk melakukan verifikasi'}
              </div>
            </div>

            {/* Kanan: Chevron */}
            <div
              style={{
                fontSize: 18,
                color: '#94a3b8',
                marginLeft: 12,
              }}
            >
              ›
            </div>

            {/* Indikator status pojok */}
            {item.status !== 'disetujui' && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: 0,
                  height: 0,
                  borderTop: '14px solid #1890ff',
                  borderLeft: '14px solid transparent',
                }}
              />
            )}
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};

// Komponen Halaman Persetujuan
const HalamanPersetujuan = ({ item, onClose, onKonfirmasi, onUpdateItem }) => {
  const [alasan, setAlasan] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSendingNote, setIsSendingNote] = useState(false); // State for note sending

  // Determine current role for display context
  let currentRole = 'kacab';
  if (item.nama_pengganti && !item.ttd_pengganti) {
    currentRole = 'pengganti';
  } else if (!item.ttd_koordinator) {
    currentRole = 'koordinator';
  } else if (!item.ttd_kacab) {
    currentRole = 'kacab';
  }

  // Extract history for this role
  let noteContent = '-';
  let tanggapanContent = '-';
  try {
    let parsedNotes = {};
    if (typeof item.catatan === 'string') {
      parsedNotes = JSON.parse(item.catatan);
    } else if (typeof item.catatan === 'object' && item.catatan !== null) {
      parsedNotes = item.catatan;
    }
    noteContent = parsedNotes[`catatan_${currentRole}`] || '-';
    tanggapanContent = parsedNotes[`tanggapan_untuk_${currentRole}`] || '-';
    console.log('parsedNotes', item.catatan);

  } catch (e) {
    console.warn('Error parsing notes', e);
  }


  // -- Update Catatan Logic --
  const handleUpdateCatatan = async () => {
    if (!alasan.trim()) {
      alert('Mohon isi catatan terlebih dahulu');
      return;
    }

    setIsSendingNote(true);
    try {
      // 1. Determine Role (same logic as approval)
      let role = 'kacab';
      if (item.nama_pengganti && !item.ttd_pengganti) {
        role = 'pengganti';
      } else if (!item.ttd_koordinator) {
        role = 'koordinator';
      } else if (!item.ttd_kacab) {
        role = 'kacab';
      }

      // 2. Prepare Payload
      // Merge with existing notes
      let existingNotes = {};
      try {
        if (typeof item.catatan === 'string') existingNotes = JSON.parse(item.catatan);
        else if (typeof item.catatan === 'object' && item.catatan) existingNotes = item.catatan;
      } catch (err) { }

      const newNoteObject = {
        text: alasan,
        timestamp: new Date().toISOString()
      };

      const CatatanJson = JSON.stringify({
        ...existingNotes,
        [`catatan_${role}`]: newNoteObject
      });

      const bodyPayload = {
        id: item.id,
        catatan: CatatanJson,
        role: role
      };

      // 3. Call API
      // Using a hypothetical endpoint for updating only notes. 
      // If backend doesn't support this specific endpoint, we might need to adjust.
      const response = await fetch('https://jne-cilacap.com/slip/public/api/update_catatan_izin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(bodyPayload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Gagal mengirim catatan');
      }

      alert('Pesan berhasil dikirim/disimpan!');

      const updatedItem = {
        ...item,
        catatan: JSON.parse(CatatanJson)
      };

      if (onUpdateItem) {
        onUpdateItem(updatedItem);
      }

    } catch (error) {
      console.error('Error update_catatan_izin:', error);
      alert('Gagal mengirim pesan: ' + error.message);
    } finally {
      setIsSendingNote(false);
    }
  };

  // -- Signature Canvas Logic --
  const canvasRef = React.useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);

  // Setup canvas size on mount
  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      // Set resolution higher for smoother lines
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
    }
  }, []);

  const getCoordinates = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / (rect.width * (window.devicePixelRatio || 1));
    const scaleY = canvas.height / (rect.height * (window.devicePixelRatio || 1));

    let clientX, clientY;

    if (event.touches && event.touches.length > 0) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }

    return {
      x: (clientX - rect.left), // * scaleX if needed, but managing with scale() usually better
      y: (clientY - rect.top)
    };
  };

  const startDrawing = (e) => {
    // e.preventDefault(); // Prevent scrolling on touch
    setIsDrawing(true);
    const { x, y } = getCoordinates(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  };

  const draw = (e) => {
    if (!isDrawing) return;
    // e.preventDefault();
    const { x, y } = getCoordinates(e);
    const ctx = canvasRef.current.getContext('2d');
    ctx.lineTo(x, y);
    ctx.stroke();
    if (!hasSignature) setHasSignature(true);
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width / (window.devicePixelRatio || 1), canvas.height / (window.devicePixelRatio || 1));
    setHasSignature(false);
  };

  const handleSubmit = (status) => {
    // if (status === 'disetujui' && !hasSignature) {
    //   alert('Mohon tanda tangan terlebih dahulu');
    //   return;
    // }

    setIsSubmitting(true);
    let signatureData = null;
    if (hasSignature && canvasRef.current) {
      signatureData = canvasRef.current.toDataURL();
    }

    // Simulasi proses
    setTimeout(() => {
      onKonfirmasi(item.id, status, alasan, signatureData);
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <motion.div
      initial={{ x: '100%' }}
      animate={{ x: 0 }}
      exit={{ x: '100%' }}
      transition={{ type: 'spring', damping: 25 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#ffffff',
        zIndex: 1000,
        overflowY: 'auto',
        padding: 24,
        fontFamily: '"Segoe UI", "Roboto", sans-serif',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32 }}>
        <motion.div
          onClick={onClose}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          style={{
            position: 'absolute',
            top: 15,
            left: 15,
            height: 24,
            width: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: '#fff',
            borderRadius: 20,
            padding: 8,
            marginTop: -3,
            cursor: 'pointer',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            zIndex: 10,
          }}
        >
          <ArrowLeft size={22} color="#333" />
        </motion.div>
        <div>
          <h2 style={{
            margin: 0,
            marginTop: -8,
            marginLeft: 45,
            fontWeight: 600,
            fontSize: 22,
            color: '#1a1a1a',
            letterSpacing: '0.3px'
          }}>
            Verifikasi Pengajuan Izin
          </h2>
          <p style={{ margin: '4px 0 0 45px', color: '#8c8c8c', fontSize: 14 }}>
            ID: {item.id} • {item.nama_karyawan}
          </p>
        </div>
      </div>

      {/* Detail Pengajuan */}
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        {/* Kartu Informasi */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          style={{
            backgroundColor: '#fafafa',
            borderRadius: 12,
            padding: 24,
            marginBottom: 32,
            border: '1px solid #f0f0f0',
          }}
        >
          <h3 style={{
            margin: '0 0 20px 0',
            fontWeight: 600,
            fontSize: 16,
            color: '#1a1a1a',
            paddingBottom: 12,
            borderBottom: '1px solid #e8e8e8'
          }}>
            Rincian Pengajuan
          </h3>

          <div style={{ display: 'grid', gap: 16 }}>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Nama :</div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{item.nama_karyawan}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Keterangan</div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{item.nama}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Mulai:</div>
              <div style={{ fontWeight: 500, fontSize: 14, color: '#1890ff' }}>
                {item.log ? item.log.split(',').map(d => d.trim()).join(' s/d ') : item.tanggal}
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Lama Izin:</div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>{item.jumlah} hari kerja</div>
            </div>
            {item.nama_pengganti && (
              <div style={{ display: 'flex' }}>
                <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Pengganti:</div>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{item.nama_pengganti}</div>
              </div>
            )}
            <div style={{ display: 'flex' }}>
              <div style={{ width: 120, color: '#595959', fontSize: 14 }}>Pengajuan:</div>
              <div style={{ fontSize: 14, color: '#8c8c8c' }}>
                {new Date(item.created_at).toLocaleString('id-ID', {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Form Persetujuan */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 12,
            padding: 24,
            border: '1px solid #f0f0f0',
            boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
          }}
        >
          <h3 style={{
            margin: '0 0 20px 0',
            fontWeight: 600,
            fontSize: 16,
            color: '#1a1a1a'
          }}>
            Form Persetujuan
          </h3>

          <div style={{ marginBottom: 24 }}>
            <label style={{
              display: 'block',
              marginBottom: 8,
              fontWeight: 500,
              fontSize: 14,
              color: '#595959'
            }}>
              Catatan / Alasan (Opsional)
            </label>

            {/* Conversation History Display */}
            {/* Conversation History Display */}
            {(() => {
              // Parse & Sort logic inline
              let parsedNotes = {};
              try {
                if (typeof item.catatan === 'string') parsedNotes = JSON.parse(item.catatan);
                else if (typeof item.catatan === 'object' && item.catatan) parsedNotes = item.catatan;
              } catch (e) { }

              const rawNote = parsedNotes[`catatan_${currentRole}`];
              const rawTanggapan = parsedNotes[`tanggapan_untuk_${currentRole}`];

              const messages = [];
              const addMsg = (content, type) => {
                if (!content || content === '-') return;
                let text = typeof content === 'object' ? content.text : content;
                let time = typeof content === 'object' ? content.timestamp : '1970-01-01T00:00:00.000Z';
                if (text && text !== '-') messages.push({ type, text, time });
              };
              addMsg(rawNote, 'note');
              addMsg(rawTanggapan, 'tanggapan');
              messages.sort((a, b) => new Date(a.time) - new Date(b.time));

              if (messages.length === 0) return null;

              return (
                <div style={{
                  marginBottom: 12,
                  padding: 12,
                  backgroundColor: '#fafafa',
                  border: '1px solid #f0f0f0',
                  borderRadius: 8,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8
                }}>
                  <div style={{ fontSize: 12, color: '#8c8c8c', marginBottom: 4 }}>Riwayat Percakapan:</div>

                  {messages.map((msg, idx) => {
                    const isNote = msg.type === 'note'; // Gray (My Note) -> Right
                    // Tanggapan (Response from User) -> Left, Blue

                    const align = isNote ? 'flex-end' : 'flex-start'; // Note on Right (Me), Response on Left (Them)

                    return (
                      <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: align }}>
                        <div style={{
                          backgroundColor: isNote ? '#f5f5f5' : '#e6f7ff',
                          border: `1px solid ${isNote ? '#d9d9d9' : '#91d5ff'}`,
                          color: isNote ? '#595959' : '#0050b3',
                          padding: '8px 12px',
                          borderRadius: isNote ? '12px 12px 0 12px' : '12px 12px 12px 0',
                          maxWidth: '90%',
                          fontSize: 13
                        }}>
                          <div style={{
                            fontSize: 10,
                            fontWeight: 700,
                            marginBottom: 2,
                            color: isNote ? '#8c8c8c' : '#1890ff',
                            textAlign: isNote ? 'right' : 'left',
                            display: 'flex',
                            justifyContent: isNote ? 'flex-end' : 'flex-start',
                            alignItems: 'center',
                            gap: 6
                          }}>
                            <span>{isNote ? 'Catatan Anda' : 'Pesan dari Pengajuan'}</span>
                            {msg.time !== '1970-01-01T00:00:00.000Z' && (
                              <span style={{ fontWeight: 400, opacity: 0.7 }}>
                                {new Date(msg.time).toLocaleString('id-ID', { hour: '2-digit', minute: '2-digit', day: 'numeric', month: 'short' })}
                              </span>
                            )}
                          </div>
                          {msg.text}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}

            <textarea
              value={alasan}
              onChange={(e) => setAlasan(e.target.value)}
              placeholder="Tambahkan catatan atau alasan persetujuan/penolakan..."
              style={{
                width: '100%',
                minHeight: 100,
                padding: 12,
                border: '1px solid #d9d9d9',
                borderRadius: 6,
                fontSize: 14,
                resize: 'vertical',
                fontFamily: 'inherit',
                boxSizing: 'border-box',
                marginBottom: 8
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={handleUpdateCatatan}
                disabled={isSendingNote || !alasan.trim()}
                style={{
                  backgroundColor: isSendingNote ? '#9ca3af' : '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '6px 12px',
                  fontSize: 12,
                  fontWeight: 500,
                  borderRadius: 6,
                  cursor: isSendingNote ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }}
              >
                {isSendingNote ? 'Mengirim...' : 'Kirim Pesan'} <div style={{ fontSize: 10 }}>➤</div>
              </button>
            </div>
          </div>

          {/* Tanda Tangan Digital */}
          <div style={{ marginBottom: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <label style={{
                fontWeight: 500,
                fontSize: 14,
                color: '#595959'
              }}>
                Tanda Tangan Digital
              </label>
              <button
                onClick={clearSignature}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#ff4d4f',
                  fontSize: 13,
                  cursor: 'pointer',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }}
              >
                🗑️ Hapus
              </button>
            </div>

            <div style={{
              border: '2px dashed #d9d9d9',
              borderRadius: 8,
              overflow: 'hidden',
              backgroundColor: '#fafafa',
              position: 'relative',
              touchAction: 'none' // Penting untuk touch device
            }}>
              <canvas
                ref={canvasRef}
                onMouseDown={startDrawing}
                onMouseMove={draw}
                onMouseUp={stopDrawing}
                onMouseLeave={stopDrawing}
                onTouchStart={startDrawing}
                onTouchMove={draw}
                onTouchEnd={stopDrawing}
                style={{
                  width: '100%',
                  height: 200,
                  display: 'block',
                  cursor: 'crosshair',
                }}
              />
              {!hasSignature && (
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  pointerEvents: 'none',
                  color: '#bfbfbf',
                  fontSize: 14,
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: 24, marginBottom: 8 }}>✍️</div>
                  Silakan tanda tangan di sini
                </div>
              )}
            </div>
          </div>

          {/* Tombol Aksi */}
          <div style={{
            display: 'flex',
            gap: 16,
            justifyContent: 'flex-end',
            paddingTop: 24,
            borderTop: '1px solid #f0f0f0'
          }}>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSubmit('ditolak')}
              disabled={isSubmitting}
              style={{
                padding: '12px 28px',
                borderRadius: 6,
                border: '1px solid #ff4d4f',
                backgroundColor: '#fff',
                color: '#ff4d4f',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                minWidth: 120,
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? 'Memproses...' : 'Tolak Pengajuan'}
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSubmit('disetujui')}
              disabled={isSubmitting}
              style={{
                padding: '12px 28px',
                borderRadius: 6,
                border: 'none',
                backgroundColor: '#1890ff',
                color: '#fff',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                minWidth: 120,
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? 'Memproses...' : 'Setujui Pengajuan'}
            </motion.button>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

const CardListIjinKonfirmasi = ({ type = 'ijin' }) => {
  const [ijinList, setIjinList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    try {
      const data = localStorage.getItem('ijin_konfirmasi');
      if (data) {
        const parsed = JSON.parse(data);
        const list = Array.isArray(parsed) ? parsed : (parsed && typeof parsed === 'object' ? [parsed] : []);

        const keuanganIds = ['kasbon', 'cicilan', 'lembur', 'piket_harian', 'perconnote'];
        const filtered = type === 'keuangan'
          ? list.filter(item => keuanganIds.includes(item.absen_id))
          : list.filter(item => !keuanganIds.includes(item.absen_id));

        setIjinList(filtered);
      }
    } catch (error) {
      console.error('Error reading ijin_konfirmasi from localStorage:', error);
    } finally {
      setLoading(false);
    }
  }, [type]);

  const handleKonfirmasi = async (id, status, alasan, signatureData) => {
    // 1. Tentukan Role berdasarkan urutan tanda tangan yang kosong
    // Urutan: Pemohon -> Pengganti (jika ada) -> Koordinator -> Kacab
    const item = ijinList.find(x => x.id === id);
    if (!item) return;

    let role = 'kacab'; // Default terakhir
    if (item.nama_pengganti && !item.ttd_pengganti) {
      role = 'pengganti';
    } else if (!item.ttd_koordinator) {
      role = 'koordinator';
    } else if (!item.ttd_kacab) {
      role = 'kacab';
    }

    // 2. Siapkan Payload
    const CatatanJson = JSON.stringify({
      [`catatan_${role}`]: alasan || '-'
    });

    // Determine konfirmasi_id based on role and localStorage data
    let konfirmasiId = null;
    console.log('role nya apa', role);
    try {
      const storedData = localStorage.getItem('data_karyawan');
      if (storedData) {
        const dataKaryawan = JSON.parse(storedData);
        if (role === 'pengganti') {
          konfirmasiId = dataKaryawan.team_absen;
        } else if (role === 'koordinator') {
          if (dataKaryawan.departement === 'operasional') {
            konfirmasiId = 315;
          } else {
            konfirmasiId = 479;
          }
        }
        // role 'kacab' defaults to null
      }
    } catch (error) {
      console.error('Error determining konfirmasi_id:', error);
    }

    const bodyPayload = {
      id: id,
      status: status === 'disetujui' ? 'DISETUJUI' : 'DITOLAK',
      catatan: CatatanJson,
      konfirmasi_id: konfirmasiId
    };

    // Tambahkan field ttd sesuai role
    if (signatureData) {
      bodyPayload[`ttd_${role}`] = signatureData;
    }

    console.log('Sending API Payload:', bodyPayload);

    // 3. Kirim ke API
    try {
      const response = await fetch('https://jne-cilacap.com/slip/public/api/approve_izin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(bodyPayload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Gagal memproses pengajuan');
      }

      console.log('API Response:', data);

      // 4. Update UI & LocalStorage (Hapus dari list agar kartu hilang)
      const updatedList = ijinList.filter(item => item.id !== id);
      setIjinList(updatedList);
      localStorage.setItem('ijin_konfirmasi', JSON.stringify(updatedList));

      setSelectedItem(null);

      await Swal.fire({
        icon: status === 'disetujui' ? 'success' : 'info',
        title: status === 'disetujui' ? 'Disetujui!' : 'Ditolak!',
        text: `Pengajuan berhasil ${status === 'disetujui' ? 'disetujui' : 'ditolak'}.`,
        confirmButtonColor: status === 'disetujui' ? '#1890ff' : '#ff4d4f',
        confirmButtonText: 'OK',
        timer: 2500,
        timerProgressBar: true,
      });

    } catch (error) {
      console.error('Error approve_izin:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Gagal!',
        text: 'Terjadi kesalahan saat mengirim data: ' + error.message,
        confirmButtonColor: '#ff4d4f',
        confirmButtonText: 'Tutup',
      });
    }
  };

  if (loading) {
    return (
      <div style={{
        textAlign: 'center',
        color: '#595959',
        marginTop: 60,
        fontSize: 15
      }}>
        Memuat data pengajuan izin...
      </div>
    );
  }

  if (ijinList.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, x: -100 }}
        transition={{ duration: 0.3 }}
        style={{
          backgroundColor: '#ffffff',
          borderRadius: 24,
          margin: '0 auto 24px auto',
          padding: '24px 20px',
          width: 'calc(100% - 32px)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid #e5e7eb',
          boxSizing: 'border-box'
        }}
      >
        <div style={{
          textAlign: 'center',
          marginBottom: 32,
          paddingBottom: 24,
          borderBottom: '1px solid #f0f0f0'
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📄</div>
          <p style={{ margin: 0 }}>Tidak ada pengajuan {type === 'ijin' ? 'izin' : 'keuangan'} yang menunggu persetujuan.</p>
          <p style={{ margin: '8px 0 0 0', fontSize: 14 }}>Semua pengajuan telah diproses.</p>
        </div>

      </motion.div>
    );
  }

  return (
    <>
      <AnimatePresence>
        {selectedItem ? (
          <HalamanPersetujuan
            item={selectedItem}
            onClose={() => setSelectedItem(null)}
            onKonfirmasi={handleKonfirmasi}
            onUpdateItem={(newItem) => {
              const updatedList = ijinList.map(i => i.id === newItem.id ? newItem : i);
              setIjinList(updatedList);
              setSelectedItem(newItem);
              localStorage.setItem('ijin_konfirmasi', JSON.stringify(updatedList));
            }}
          />
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.3 }}
            style={{
              backgroundColor: '#ffffff',
              borderRadius: 24,
              margin: '0 auto 24px auto',
              padding: '24px 20px',
              width: 'calc(100% - 32px)',
              boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              border: '1px solid #e5e7eb',
              boxSizing: 'border-box'
            }}
          >
            {/* Header */}
            <div style={{
              textAlign: 'center',
              marginBottom: 32,
              paddingBottom: 24,
              borderBottom: '1px solid #f0f0f0'
            }}>
              <h2 style={{
                fontWeight: 600,
                fontSize: 22,
                margin: '0 0 8px 0',
                color: '#1a1a1a',
                letterSpacing: '0.3px'
              }}>
                Daftar Pengajuan {type === 'ijin' ? 'Izin' : 'Keuangan'}
              </h2>
              <p style={{
                margin: 0,
                color: '#8c8c8c',
                fontSize: 14
              }}>
                {ijinList.length} pengajuan menunggu verifikasi
              </p>
            </div>

            {/* Daftar Card */}
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              overflowX: 'auto',
              gap: 16,
              paddingBottom: 12,
              paddingTop: 4,
              paddingLeft: 15,
              paddingRight: 15,
              scrollSnapType: 'x mandatory',
              WebkitOverflowScrolling: 'touch',
            }}>
              {ijinList.map((item) => (
                <div key={item.id} style={{ minWidth: 280, maxWidth: 340, flex: '0 0 auto', scrollSnapAlign: 'start' }}>
                  <CardIjinKonfirmasi
                    item={item}
                    onSetujuClick={setSelectedItem}
                  />
                </div>
              ))}
            </div>

            {/* Footer */}
            {/* <div style={{
              marginTop: 32,
              paddingTop: 20,
              borderTop: '1px solid #f0f0f0',
              textAlign: 'center',
              color: '#8c8c8c',
              fontSize: 13
            }}>
              <p style={{ margin: 0 }}>
                Klik area <span style={{ fontWeight: 500, color: '#1890ff' }}>"Berikan Persetujuan"</span> untuk memverifikasi setiap pengajuan
              </p>
            </div> */}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CardListIjinKonfirmasi;